import { GlobalNotification } from '../models/global-notification.model';

export interface GlobalNotificationResponse {
  data: GlobalNotification[];
  count: number;
  page: number;
  pageCount: number;
  total: number;
}
